module.exports = __webpack_public_path__ + "static/media/start_poster-welsh.6c6ac887.jpg";